/*
 * @Author: guoguo ybbhai@hotmail.com
 * @Date: 2023-10-07 10:50:41
 * @LastEditors: guoguo ybbhai@hotmail.com
 * @LastEditTime: 2023-10-10 21:55:41
 * @FilePath: \web\src\api\type.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import request from '../utils/request'

// 获取所有新闻类型
export const getAll = data => {
  return request({
    method: 'GET',
    url: `/news_type/all`,
    params: data,
  })
}
// 修改新闻类型
export const updateType = data => {
  return request({
    method: 'PUT',
    url: '/news_type/update',
    data: data
  })
}
// 删除新闻类型
export const deleteType = data => {
  return request({
    method: 'DELETE',
    url: '/news_type/delete',
    params: data
  })
}
// 批量删除
export const deleteBatchTypes = data => {
  return request({
    method: 'POST',
    url: '/news_type/deleteBatch',
    data: { ids: data }
  })
}
// 添加新闻类型
export const addType = data => {
  return request({
    method: 'POST',
    url: '/news_type/add',
    data: data
  })
}
export const getOptions = data => {
  return request({
    method: 'GET',
    url: `/news_type/queryOptions`,
    params: data,
  })
}